import React, { useEffect } from 'react';
import { AuthStateStorageService, LoadingSpinner } from 'common.ui';
import { useMsal } from 'auth/MsalContext';
import { useLocation } from 'react-router-dom';
import Page from '../../components/page/Page';

function LoginInternal() {
  const { ensureInternalUserLogin, authInProgress } = useMsal();
  const location = useLocation();

  useEffect(() => {
    if (authInProgress) return;

    const redirectUrl = new URLSearchParams(location.search).get('redirectUrl');

    if (redirectUrl) AuthStateStorageService.setRedirectionState(redirectUrl);

    ensureInternalUserLogin();
  }, [authInProgress, ensureInternalUserLogin, location.search]);

  return (
    <Page header='Logg inn som intern ansatte' title='Logg inn'>
      <LoadingSpinner />
    </Page>
  );
}

export default LoginInternal;
